import type PriceType from '../PriceType';
import HotelPriceClass from './HotelPriceClass';
import {
    type HotelRoomTypeConfigView,
    type HotelResponseRoomType,
    type PhotoSizeCollection,
    SupplierLimitationsType,
    type HotelResponseRoomPrice,
} from '@clients/HotelApi';

export default class HotelRoomType implements PriceType<HotelPriceClass> {
    title?: string;
    roomConfigs: HotelRoomTypeConfigView[] = [];
    hasExtraBed = false;
    extraBedCount = 0;
    extraBedPrice = 0;
    roomAmenities: string[] = [];
    classes: HotelPriceClass[] = [];
    capacity = 0;
    image?: PhotoSizeCollection;
    onlyThisTypeSelectable = false;
    description?: string;
    constructor(
        room: HotelResponseRoomType & {
            checkoutHour: string;
            checkinHour: string;
        },
        price: HotelResponseRoomPrice
    ) {
        this.description = room.description || '';
        this.title = room.name || '';
        this.roomConfigs = room.roomConfigs || [];
        this.hasExtraBed = room.hasExtraBed || false;
        this.extraBedCount = room.extraBedCapacity || 0;
        this.roomAmenities = room.roomTypeAmenities || [];
        this.capacity = room.capacity || 0;
        this.onlyThisTypeSelectable =
            room.supplierLimitationsType ===
            SupplierLimitationsType.HasRoomTypeLimitation;
        this.classes = [
            new HotelPriceClass(price, {
                hasExtraBed: room.hasExtraBed || false,
                extraBedCapacity: room.extraBedCapacity || 0,
                checkoutHour: room.checkoutHour,
                checkinHour: room.checkinHour,
                uniqueId: room.uniqueId || '',
                onlyThisClassSelectable:
                    room.supplierLimitationsType ===
                    SupplierLimitationsType.HasServiceLevelLimitation,
            }),
        ];
        this.image = room.photo;
    }

    get id(): string {
        return this.classes.reduce((id, curr) => id + curr.id, '');
    }

    /**
     * get cheapest price class
     *
     * @readonly
     * @type {HotelPriceClass}
     * @memberof HotelRoomType
     */
    get cheapestPriceClass(): HotelPriceClass | null {
        const firstAvailableIndex = this.classes.findIndex(c => c.capacity > 0);
        if (firstAvailableIndex < 0) {
            return null;
        }
        return this.classes.reduce((chPrice, price) => {
            if (
                price.capacity > 0 &&
                price.singlePayable < chPrice.singlePayable
            ) {
                return price;
            } else {
                return chPrice;
            }
        }, this.classes[firstAvailableIndex]);
    }

    get isFloating() {
        return this.classes.every(p => p.isFloating);
    }
}
